import { connectRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import { combineReducers } from "redux";

import { fileUploadReducer } from "../../features/fileUpload";

import appEngineReducer from "./appEngine";
import billingReducer from "./billingReducer";
import carrierSettingReducer from "./carrierSetting";
import dpAccountReducer from "./dpAccountReducer";
import pickupReducer from "./pickupReducer";
import pincodeServiceabilityReducer from "./pincodeServiceabilityReducer";
import ratingReducer from "./ratingReducer";
import shipmentReducer from "./shipmentReducer";
import userReducer from "./userReducer";
import warehouseReducer from "./warehouseReducer";

export const makeRootReducer = (asyncReducers) =>
	combineReducers({
		user: userReducer,
		warehouse: warehouseReducer,
		shipment: shipmentReducer,
		serviceability: pincodeServiceabilityReducer,
		billing: billingReducer,
		pickup: pickupReducer,
		rating: ratingReducer,
		dpAccount: dpAccountReducer,
		appEngine: appEngineReducer,
		carrierSetting: carrierSettingReducer,
		fileUpload: fileUploadReducer,
		router: connectRouter(createBrowserHistory()),
		...asyncReducers,
	});

export default makeRootReducer;
